export const ROUTERS_PATH = {
  SELECTIONS: '/',
  NEW_SELECTION: '/new-selection',
};
